import { INDENTATION, ALIGNMENT } from '../groups.js';

var alignment = {
    excludes: "alignment " + INDENTATION,
    group: ALIGNMENT,
    attrs: {
        align: {},
    },
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function (dom) {
                var align = dom.getAttribute('data-align');
                return align ? { align: align } : false;
            },
        },
    ],
    toDOM: function (mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-align-" + mark.attrs.align,
                'data-align': mark.attrs.align,
            },
            0,
        ];
    },
};

export { alignment };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/alignment.js